const ALONGSLIDE_DESKTOP_SIZES = [
  [728, 90],
  [468, 60],
]

const ALONGSLIDE_DESKTOP_SIZE_MAPPING = [
  [
    [1150, 768],
    [
      [728, 90],
      [468, 60],
    ],
  ],
  [[728, 480], [[468, 60]]],
  [[0, 0], []],
]

const ALONGSLIDE_DESKTOP_ADS = {
  alongslideDesktop1: {
    path: "Slideshow_Page_Alongside_Preso_Desktop_1",
    sizes: ALONGSLIDE_DESKTOP_SIZES,
    sizeMapping: ALONGSLIDE_DESKTOP_SIZE_MAPPING,
    id: "alongslide-player-desktop-ad-1",
    shouldRefresh: false,
  },
  alongslideDesktop2: {
    path: "Slideshow_Page_Alongside_Preso_Desktop_2",
    sizes: ALONGSLIDE_DESKTOP_SIZES,
    sizeMapping: ALONGSLIDE_DESKTOP_SIZE_MAPPING,
    id: "alongslide-player-desktop-ad-2",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideDesktop3: {
    path: "Slideshow_Page_Alongside_Preso_Desktop_3",
    sizes: ALONGSLIDE_DESKTOP_SIZES,
    sizeMapping: ALONGSLIDE_DESKTOP_SIZE_MAPPING,
    id: "alongslide-player-desktop-ad-3",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideDesktop4: {
    path: "Slideshow_Page_Alongside_Preso_Desktop_4",
    sizes: ALONGSLIDE_DESKTOP_SIZES,
    sizeMapping: ALONGSLIDE_DESKTOP_SIZE_MAPPING,
    id: "alongslide-player-desktop-ad-4",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideDesktop5: {
    path: "Slideshow_Page_Alongside_Preso_Desktop_5",
    sizes: ALONGSLIDE_DESKTOP_SIZES,
    sizeMapping: ALONGSLIDE_DESKTOP_SIZE_MAPPING,
    id: "alongslide-player-desktop-ad-5",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideDesktop6: {
    path: "Slideshow_Page_Alongside_Preso_Desktop_6",
    sizes: ALONGSLIDE_DESKTOP_SIZES,
    sizeMapping: ALONGSLIDE_DESKTOP_SIZE_MAPPING,
    id: "alongslide-player-desktop-ad-6",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideDesktop7: {
    path: "Slideshow_Page_Alongside_Preso_Desktop_7",
    sizes: ALONGSLIDE_DESKTOP_SIZES,
    sizeMapping: ALONGSLIDE_DESKTOP_SIZE_MAPPING,
    id: "alongslide-player-desktop-ad-7",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideDesktop8: {
    path: "Slideshow_Page_Alongside_Preso_Desktop_8",
    sizes: ALONGSLIDE_DESKTOP_SIZES,
    sizeMapping: ALONGSLIDE_DESKTOP_SIZE_MAPPING,
    id: "alongslide-player-desktop-ad-8",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideDesktop9: {
    path: "Slideshow_Page_Alongside_Preso_Desktop_9",
    sizes: ALONGSLIDE_DESKTOP_SIZES,
    sizeMapping: ALONGSLIDE_DESKTOP_SIZE_MAPPING,
    id: "alongslide-player-desktop-ad-9",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideDesktop10: {
    path: "Slideshow_Page_Alongside_Preso_Desktop_10",
    sizes: ALONGSLIDE_DESKTOP_SIZES,
    sizeMapping: ALONGSLIDE_DESKTOP_SIZE_MAPPING,
    id: "alongslide-player-desktop-ad-10",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
}

const ALONGSLIDE_MOBILE_ADS = {
  alongslideMobile1: {
    path: "Slideshow_Page_Alongside_Preso_Mobile_1",
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-1",
    shouldRefresh: false,
  },
  alongslideMobile2: {
    path: "Slideshow_Page_Alongside_Preso_Mobile_2",
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-2",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideMobile3: {
    path: "Slideshow_Page_Alongside_Preso_Mobile_3",
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-3",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideMobile4: {
    path: "Slideshow_Page_Alongside_Preso_Mobile_4",
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-4",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideMobile5: {
    path: "Slideshow_Page_Alongside_Preso_Mobile_5",
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-5",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideMobile6: {
    path: "Slideshow_Page_Alongside_Preso_Mobile_6",
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-6",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideMobile7: {
    path: "Slideshow_Page_Alongside_Preso_Mobile_7",
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-7",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideMobile8: {
    path: "Slideshow_Page_Alongside_Preso_Mobile_8",
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-8",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideMobile9: {
    path: "Slideshow_Page_Alongside_Preso_Mobile_9",
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-9",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslideMobile10: {
    path: "Slideshow_Page_Alongside_Preso_Mobile_10",
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-10",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
}

export const ADS = {
  ...ALONGSLIDE_DESKTOP_ADS,
  abovePlayerDesktop: {
    path: "Slideshow_Page_Above_Reader_Incl_Large_Leaderboard_30_Sec_Refresh",
    sizes: [
      [728, 90],
      [970, 90],
    ],
    id: "above-player-desktop-ad",
    shouldRefresh: true,
  },
  aboveRecsDesktop: {
    path: "Slideshow_Page_Above_Recs_Desktop_30_Sec_Refresh",
    sizes: [
      [300, 250],
      [200, 200],
      [336, 280],
      [250, 250],
    ],
    id: "above-recs-desktop-ad",
    shouldRefresh: true,
  },
  ...ALONGSLIDE_MOBILE_ADS,
  abovePlayerMobile: {
    path: "Slideshow_Page_Above_Reader_Incl_Large_Mobile_Web_30_Sec_Refresh",
    sizes: [
      [320, 50],
      [300, 50],
    ],
    id: "above-player-mobile-ad",
    shouldRefresh: true,
  },
  aboveRecsMobile: {
    path: "Slideshow_Page_Above_Recs_Mobile_Web",
    sizes: [
      [200, 200],
      [300, 250],
      [250, 250],
      [336, 280],
    ],
    id: "above-recs-mobile-ad",
    shouldRefresh: false,
  },
  belowReader: {
    path: "Slideshow_Page_Below_Reader_Incl_Large_Leaderboard",
    sizes: [
      [200, 200],
      [250, 250],
      [300, 50],
      [300, 250],
      [320, 50],
      [728, 90],
      [970, 90],
    ],
    id: "below-reader-ad",
    shouldRefresh: false,
    sizeMapping: [
      // If screen is wider than 970px, show either 970 or 728px wide
      [
        [970, 768],
        [
          [970, 90],
          [728, 90],
        ],
      ],
      // If screen is between 728px and 970px wide, show 728px wide
      [[728, 480], [[728, 90]]],
      // If screen is between 320px and 728px wide, show either 300 or 320px wide
      [
        [320, 300],
        [
          [300, 50],
          [300, 250],
          [320, 50],
        ],
      ],
      // If screen is between 250 and 320px wide, show either 200 or 250px wide
      [
        [250, 200],
        [
          [200, 200],
          [250, 250],
        ],
      ],
      // If screen is less than 250px wide, show no ads
      [[0, 0], []],
    ],
  },
  betweenRecs1: {
    path: "Slideshow_Page_Between_Below_Fold_Carousels_Many_Formats",
    sizes: [
      [200, 200],
      [250, 250],
      [300, 250],
      [336, 280],
      [468, 60],
      [728, 90],
      [970, 90],
      [970, 250],
    ],
    id: "between-recs-ad-1",
    shouldRefresh: false,
    sizeMapping: [
      [
        [970, 768],
        [
          [970, 90],
          [970, 250],
        ],
      ],
      [
        [728, 480],
        [
          [728, 90],
          [468, 60],
        ],
      ],
      [
        [336, 300],
        [
          [300, 250],
          [336, 280],
        ],
      ],
      [
        [250, 200],
        [
          [200, 200],
          [250, 250],
        ],
      ],
      [[0, 0], []],
    ],
  },
  betweenRecs2: {
    path: "Slideshow_Page_Between_Below_Fold_Carousels_Many_Formats_2",
    sizes: [
      [200, 200],
      [250, 250],
      [300, 250],
      [336, 280],
      [468, 60],
      [728, 90],
      [970, 90],
      [970, 250],
    ],
    id: "between-recs-ad-2",
    shouldRefresh: false,
    sizeMapping: [
      [
        [970, 768],
        [
          [970, 90],
          [970, 250],
        ],
      ],
      [
        [728, 480],
        [
          [728, 90],
          [468, 60],
        ],
      ],
      [
        [336, 300],
        [
          [300, 250],
          [336, 280],
        ],
      ],
      [
        [250, 200],
        [
          [200, 200],
          [250, 250],
        ],
      ],
      [[0, 0], []],
    ],
  },
}
